export class Constants {
  public static SHOW_MELDUNG_STATE = 'onTouched'; // Alternativen: onTouched / onDirty / allways
}
